import React from 'react';
import { Card } from '../ui/card';
import { Trash2, RotateCcw } from 'lucide-react';
import { sectorAvailable, seatKey } from '../../lib/arenaUtils';

// Szektor lista - kompakt áttekintés szektoronként + tömeges szektor kivétel/visszaállítás
export default function SectorList({ sectors, removedSeats, setRemovedSeats }) {
  const toggleSector = (sector) => {
    const total = sector.seats?.length || 0;
    const removed = (removedSeats[sector.id] || []).length;
    const allRemoved = removed === total;
    setRemovedSeats((prev) => {
      if (allRemoved) return { ...prev, [sector.id]: [] };
      const all = (sector.seats || []).map((seat) => seatKey(seat.r, seat.s));
      return { ...prev, [sector.id]: all };
    });
  };

  return (
    <Card className="p-4 bg-white border-stone-200" data-testid="sector-list">
      <h3 className="text-sm font-bold tracking-wide text-stone-800 uppercase mb-3">
        Szektorok ({sectors.length})
      </h3>
      <div className="space-y-1.5 max-h-[320px] overflow-y-auto pr-1">
        {sectors.map((s) => {
          const { total, removed, available } = sectorAvailable(s, removedSeats);
          const allRemoved = removed === total && total > 0;
          return (
            <div
              key={s.id}
              className="grid grid-cols-[auto_1fr_auto_auto] items-center gap-2 py-1.5 border-b border-stone-100 last:border-0"
              data-testid={`sector-row-${s.id}`}
            >
              <span
                className="inline-block w-3 h-3 rounded-sm flex-shrink-0"
                style={{ background: s.color }}
              />
              <div className="min-w-0">
                <div className="text-xs font-bold text-stone-800">{s.name}</div>
                <div className="text-[10px] text-stone-500 truncate">
                  {s.rows} sor • max {s.maxSeatsPerRow}
                </div>
              </div>
              <div className="text-right">
                <div className="text-[11px] font-bold tabular-nums text-stone-900">
                  {available}/{total}
                </div>
                {removed > 0 && (
                  <div className="text-[9px] text-rose-500 tabular-nums">-{removed}</div>
                )}
              </div>
              <button
                onClick={() => toggleSector(s)}
                title={allRemoved ? 'Szektor visszaállítása' : 'Egész szektor kivétele'}
                className={`w-6 h-6 rounded flex items-center justify-center transition-colors ${
                  allRemoved
                    ? 'bg-emerald-100 text-emerald-700 hover:bg-emerald-200'
                    : 'bg-stone-100 text-stone-500 hover:bg-rose-100 hover:text-rose-600'
                }`}
                data-testid={`toggle-sector-${s.id}`}
              >
                {allRemoved ? <RotateCcw className="w-3 h-3" /> : <Trash2 className="w-3 h-3" />}
              </button>
            </div>
          );
        })}
      </div>
      <div className="text-[10px] text-stone-400 mt-3">
        Tipp: a kuka ikonnal egész szektort kivehetsz; az adatok automatikusan a PDF-ből.
      </div>
    </Card>
  );
}
